<span class="badge badge-pedido-status badge-pedido-status-confirmando-erp">
    {{status.nome}}
</span>